import { StyleSheet } from "react-native";

export const printCustomerStyle = StyleSheet.create({
    profileView: {
        flexDirection: "row",
        alignItems: "flex-start",
        justifyContent: "space-between",
    },
    printButtonView: {
        paddingVertical: 20,
        justifyContent: "center",
        alignItems: "center"
    },
    loyaltyView: {
        flexDirection: "row",
        alignItems: "center",
        paddingVertical: 5,
        justifyContent: "space-between"
    }

})